import { defineStore } from "pinia";
import OptionValueInterface from "@/api/domain/option-value.interface";
import CommonService from "@/api/services/common.service";
import _ from "lodash";
import {toRaw} from "vue";

const commonService = new CommonService();
export const useCommonStore = defineStore("common", {
  state: () => ({
    appConfig: {
      openDataPrefix: "https://opendata.dbd.go.th/dataset/"
    },
    objectiveOptions: Array<OptionValueInterface>(),
    updateFrequencyUnitOptions: Array<OptionValueInterface>(),
    geoCoverageOptions: Array<OptionValueInterface>(),
    dataFormatOptions: Array<OptionValueInterface>(),
    dataCategoryOptions: Array<OptionValueInterface>(),
    licenseTypeOptions: Array<OptionValueInterface>(),
    dataSupportOptions: Array<OptionValueInterface>(),
    dataCollectOptions: Array<OptionValueInterface>(),
    dataLanguageOptions: Array<OptionValueInterface>(),
    disaggregateOptions: Array<OptionValueInterface>(),
    dataTypeOptions: Array<OptionValueInterface>(),
    unitOfMultiplierOptions: Array<OptionValueInterface>(),
    geoGraphicOptions: Array<OptionValueInterface>(),
    equivalentScaleOptions: Array<OptionValueInterface>()
  }),
  actions: {
    async getObjectiveOptions() {
      this.objectiveOptions = await commonService.getObjectiveOptions();
    },
    async getUpdateFrequencyUnitOptions() {
      this.updateFrequencyUnitOptions = await commonService.getUpdateFrequencyUnitOptions();
    },
    async getGeoCoverageOptions() {
      this.geoCoverageOptions = await commonService.getGeoCoverageOptions();
    },
    async getDataFormatOptions() {
      this.dataFormatOptions = await commonService.getDataFormatOptions();
    },
    async getDataCategoryOptions() {
      this.dataCategoryOptions = await commonService.getDataCategoryOptions();
    },
    async getLicenseTypeOptions() {
      this.licenseTypeOptions = await commonService.getLicenseTypeOptions();
    },
    async getDataSupportOptions() {
      this.dataSupportOptions = await commonService.getDataSupportOptions();
    },
    async getDataCollectOptions() {
      this.dataCollectOptions = await commonService.getDataCollectOptions();
    },
    async getDataLanguageOptions() {
      this.dataLanguageOptions = await commonService.getDataLanguageOptions();
    },
    async getDisaggregateOptions() {
      this.disaggregateOptions = await commonService.getDisaggregateOptions();
    },
    async getDataTypeOptions() {
      this.dataTypeOptions = await commonService.getDataTypesOptions();
    },
    async getUnitOfMultiplierOptions() {
      this.unitOfMultiplierOptions = await commonService.getMultiplierUnitOptions();
    },
    async getGeoGraphicOptions() {
      this.geoGraphicOptions = await commonService.getGeoGraphicOptions();
    },
    async getEquivalentScaleOptions() {
      this.equivalentScaleOptions = await commonService.getEquivalentScaleOptions();
    },
    dataTypeName(value : string) {
      const result : { value: string } | undefined = _.find(this.dataTypeOptions, {value});

      return toRaw(result)
    },
    updateFrequencyUnitName(values : string, other : string) {
      // const result : { value: string } | undefined = _.find(this.updateFrequencyUnitOptions,{value});

      let result : string | undefined = "";
      let val : { name: string, value: string } | undefined;

      values?.split("|").forEach((value,index) => {
        val = _.find(this.updateFrequencyUnitOptions,{value});

        if(val?.value != "12") {
          result += val?.name + "";
        }

        if(index != values?.split("|").length - 1) {
          result += ",";
        }
      });

      return result + (other || "");
    },
    dataFormatName(values : string, other : string) {
      let result : string | undefined = "";
      let val : { name: string, value: string } | undefined;

      console.log(":>>>>>: " + values);

      values?.split("|").forEach((value,index) => {
        val = _.find(this.dataFormatOptions,{value});

        if(val?.value != "12") {
          result += val?.name + "";
        }

        if(index != values?.split("|").length - 1) {
          result += ",";
        }
      });

      return result + (other || "");
    },
    objectiveName(values : string, other : string) {
      let result : string | undefined = "";
      let val : { name: string, value: string } | undefined;

      values?.split("|").forEach((value,index) => {
        val = _.find(this.objectiveOptions,{value});

        if(val?.value != "12") {
          result += val?.name + "";
        }

        if(index != values?.split("|").length - 1) {
          result += ",";
        }
      });

      return result + (other || "");
    },
    geoCoverageName(values : string, other : string) {
      let result : string | undefined = "";
      let val : { name: string, value: string } | undefined;

      values?.split("|").forEach((value,index) => {
        val = _.find(this.geoCoverageOptions,{value});

        if(val?.value != "12") {
          result += val?.name + "";
        }

        if(index != values?.split("|").length - 1) {
          result += ",";
        }
      });

      return result + (other || "");
    },
    dataCategoryName(value : string) {
      // const result : { value: string } | undefined = _.find(this.dataCategoryOptions,{value});
      //
      // return toRaw(result);
      const result : { name: string, value: string } | undefined = _.find(this.dataCategoryOptions, {value});

      return result?.name;

      // let val : { name: string, value: string } | undefined;
      //
      // val = _.find(this.dataCategoryOptions, {value});
      //
      // return val?.name;
    },
    licenseTypeName(values : string, other : string) {
      let result : string | undefined = "";
      let val : { name: string, value: string } | undefined;

      values?.split("|").forEach((value,index) => {
        val = _.find(this.licenseTypeOptions,{value});

        if(val?.value != "12") {
          result += val?.name + "";
        }

        if(index != values?.split("|").length - 1) {
          result += ",";
        }
      });

      return result + (other || "");
    },
    dataLanguageName(values : string, other : string) {
      let result : string | undefined = "";
      let val : { name: string, value: string } | undefined;

      values?.split("|").forEach((value,index) => {
        val = _.find(this.dataLanguageOptions,{value});

        if(val?.value != "12") {
          result += val?.name + "";
        }

        if(index != values?.split("|").length - 1) {
          result += ",";
        }
      });

      return result + (other || "");
    },
    dataSupportName(values : string, other : string) {
      let result : string | undefined = "";
      let val : { name: string, value: string } | undefined;

      values?.split("|").forEach((value,index) => {
        val = _.find(this.dataSupportOptions,{value});

        if(val?.value != "12") {
          result += val?.name + "";
        }

        if(index != values?.split("|").length - 1) {
          result += ",";
        }
      });

      return result + (other || "");
    },
    disaggregateName(values : string, other : string) {
      let result : string | undefined = "";
      let val : { name: string, value: string } | undefined;

      values?.split("|").forEach((value,index) => {
        val = _.find(this.disaggregateOptions,{value});

        if(val?.value != "12") {
          result += val?.name + "";
        }

        if(index != values?.split("|").length - 1) {
          result += ",";
        }
      });

      return result + (other || "");
    },
    unitOfMultiplierName(values : string, other : string) {
      let result : string | undefined = "";
      let val : { name: string, value: string } | undefined;

      values?.split("|").forEach((value,index) => {
        val = _.find(this.unitOfMultiplierOptions,{value});

        if(val?.value != "12") {
          result += val?.name + "";
        }

        if(index != values?.split("|").length - 1) {
          result += ",";
        }
      });

      return result + (other || "");
    },
    dataCollectName(values : string, other : string) {
      let result : string | undefined = "";
      let val : { name: string, value: string } | undefined;

      values?.split("|").forEach((value,index) => {
        val = _.find(this.dataCollectOptions,{value});

        if(val?.value != "12") {
          result += val?.name + "";
        }

        if(index != values?.split("|").length - 1) {
          result += ",";
        }
      });

      return result + (other || "");
    },
    geoGraphicName(value : string) {
      const result : { value: string } | undefined = _.find(this.geoGraphicOptions,{value})

      return result;
    },
    equivalentScaleName(values : string, other : string) {
      let result : string | undefined = "";
      let val : { name: string, value: string } | undefined;

      values?.split("|").forEach((value,index) => {
        val = _.find(this.equivalentScaleOptions,{value});

        if(val?.value != "12") {
          result += val?.name + "";
        }

        if(index != values?.split("|").length - 1) {
          result += ",";
        }
      });

      return result + (other || "");
    }
    // getDataTypeByValue(value: string) : OptionValueInterface | undefined {
    //   const result : {name:string,value:string} | undefined = _.find(this.dataTypeOptions, { value });
    //   return result;
    // },
  },
  getters: {},
});
